<template>
  <div class="SessionFulfilledModal">
    <h1 class="SessionFulfilledModal-title">{{ title }}</h1>
    <div class="SessionFulfilledModal-message">{{ message }}</div>
    <large-button v-if="mobileMode" primary @click.native="onAccept">{{
      modalData.acceptText
    }}</large-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LargeButton from '@/components/LargeButton.vue'
import i18n from '@/i18n'

export default {
  name: 'SessionFulfilledModal',
  components: { LargeButton },
  props: {
    modalData: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      mobileMode: 'app/mobileMode',
      isVolunteer: 'user/isVolunteer',
    }),
    message() {
      const {
        isSessionEnded,
        volunteerJoined,
        isSessionVolunteer,
        isSessionStudent,
      } = this.modalData
      const thankYouMessage = this.$root.$t(
        'session.sessionFulfilledModal.thankYouMessage'
      )
      let text = ''

      if (isSessionEnded && !volunteerJoined) {
        if (isSessionStudent) {
          text = this.$root.$t(
            'session.sessionFulfilledModal.isSessionStudentText'
          )
        }
        if (this.isVolunteer) {
          text = this.$root.$t(
            'session.sessionFulfilledModal.isVolunteerText',
            {
              thankYouMessage: thankYouMessage,
            }
          )
        }
      } else if (volunteerJoined && !isSessionVolunteer && this.isVolunteer) {
        text = this.$root.$t(
          'session.sessionFulfilledModal.volunteerJoinedText',
          {
            thankYouMessage: thankYouMessage,
          }
        )
      } else {
        text = this.$root.$t('session.sessionFulfilledModal.finishedText')
      }

      return text
    },
    title() {
      const { isSessionEnded, volunteerJoined } = this.modalData

      if (isSessionEnded && !volunteerJoined) {
        return this.$root.$t('session.sessionFulfilledModal.sessionCanceled')
      } else {
        return this.$root.$t('session.sessionFulfilledModal.sessionFullFilled')
      }
    },
  },
  methods: {
    onAccept() {
      this.$router.push(`/${i18n.locale}/dashboard`)
    },
  },
}
</script>

<style lang="scss" scoped>
.SessionFulfilledModal {
  @include flex-container(column);
  @include child-spacing(top, 24px);
  @include breakpoint-above('medium') {
    @include child-spacing(top, 16px);
  }
}

.SessionFulfilledModal-title {
  @include font-category('display-small');
  @include breakpoint-above('medium') {
    margin-top: 24px;
  }
}

.SessionFulfilledModal-message {
  @include font-category('body');
}
</style>
